import { createContext } from 'react';

import type { SiteChromeStaticContextValue } from './types';

export const SiteChromeStaticContext = createContext<SiteChromeStaticContextValue | undefined>(
  undefined,
);
